import { notification } from "antd";

export const CustomNotification = (type, msg, descriptiond) => {
    notification[type]({
      message: msg,
      description: descriptiond,
    });
  };